@if (!isHeaderHidden() && authenticated()) {
    <!-- Skip to content link -->
    <a class="skip-link" href="#main-content" [translate]="'global.navbar.aria.skipToContent'" (click)="skipToContent($event)"></a>

    <!-- Main Topbar -->
    <header id="header-top-menu" class="header-top-menu main-topbar">
        <a routerLink="/" class="margin-right-auto" [attr.aria-label]="'global.navbar.aria.goToHomePage' | translate">
            <img role="img" class="main-topbar__logo" src="/assets/img/logo-dialenga-texto.svg" alt="Dialenga" />
        </a>

        <!-- Help button -->
        <div class="margin-right-16">
            <button
                type="button"
                class="main-topbar__button"
                kendoPopoverAnchor
                [popover]="helpMenuOptions"
                [showOn]="'click'"
                [attr.aria-label]="'global.navbar.aria.openHelpMenu' | translate">
                <span class="icon icon-help-outline icon-24" aria-hidden="true"></span>
            </button>
            <kendo-popover
                #helpMenuOptions
                [width]="'auto'"
                [position]="'bottom'"
                [callout]="false"
                [offset]="10"
                [animation]="{type: 'fade', duration: 150, direction: 'down'}"
                (shown)="onPopoverShown($event, 'help-menu')">
                <ng-template kendoPopoverBodyTemplate>
                    <div class="help-menu__wrapper flex">
                        <ul class="help-menu__list" role="menu" [attr.aria-label]="'global.navbar.aria.helpMenu' | translate">
                            <!-- New features current version | Change Log -->
                            <li class="help-menu-item" role="none">
                                <span class="help-menu-item__icon icon icon-new-box" aria-hidden="true"></span>
                                <span class="help-menu-item__title" [translate]="'global.whatsNew'"></span>
                                <div class="flex align-items-center">
                                    <button
                                        class="help-menu-item__link"
                                        role="menuitem"
                                        [translate]="'global.fromThisVersion'"
                                        (click)="openNewFeaturesAdvice()"></button>
                                    <span class="black-30 margin-inline-8" aria-hidden="true">|</span>
                                    <button
                                        class="help-menu-item__link"
                                        role="menuitem"
                                        [translate]="'global.changeLog'"
                                        (click)="openInNewTab('https://support.dialenga.com/external/knowledge-base/article/146')"></button>
                                </div>
                            </li>
                            <!-- Dialenga help center -->
                            <li role="none">
                                <button class="help-menu-item" role="menuitem" (click)="openInNewTab('https://support.dialenga.com/external')">
                                    <span class="help-menu-item__icon icon icon-help-book" aria-hidden="true"></span>
                                    <span class="help-menu-item__title" [translate]="'global.helpCenter'"></span>
                                    <span class="help-menu-item__description" [translate]="'global.helpCenterDescription'"></span>
                                </button>
                            </li>
                            <!-- Dialenga feedback form -->
                            <li role="none">
                                <button class="help-menu-item" role="menuitem" (click)="goToDialengaFeedbackForm()">
                                    <span class="help-menu-item__icon icon icon-feedback" aria-hidden="true"></span>
                                    <span class="help-menu-item__title" [translate]="'global.sendFeedback'"></span>
                                    <span class="help-menu-item__description" [translate]="'global.feedbackDescription'"></span>
                                </button>
                            </li>
                        </ul>
                        <!-- Other advices -->
                        @if (false) {
                            <section class="menu-highlight" role="region">
                                <div class="padding-24">
                                    <h3 class="menu-highlight__tag" [translate]="'global.notice.tag'"></h3>
                                    <p class="menu-highlight__text margin-top-24" [translate]="'global.notice.text'"></p>
                                    <button
                                        class="button button--secondary margin-top-32"
                                        [style.width]="'fit-content'"
                                        (click)="openInNewTab('https://dialenga.typeform.com/encuesta-2025')">
                                        <span class="button__label" [translate]="'global.notice.btnText'"></span>
                                    </button>
                                </div>
                                <img src="/assets/img/header-notice-img.png" alt="" aria-hidden="true" />
                            </section>
                        }
                    </div>
                </ng-template>
            </kendo-popover>
        </div>

        <!-- Audit button -->
        @if (userLoggedHasAdminRole()) {
            <a
                routerLink="/audit"
                class="main-topbar__button icon icon-activity margin-right-16"
                kendoTooltip
                [title]="'global.navbar.systemActivities' | translate">
            </a>
        }

        <!-- User logged dropdown: Profile | Privacy policy | Terms and conditions | Personal data treatment | Logout -->
        <article>
            <button
                type="button"
                class="main-topbar__user"
                #userLoggedMenu="kendoPopoverAnchor"
                kendoPopoverAnchor
                [popover]="userLoggedOptions"
                [showOn]="'click'"
                [attr.aria-label]="'global.navbar.aria.userMenu' | translate"
                aria-haspopup="menu">
                <user-avatar
                    [medium]="true"
                    [user]="{
                        name: loggedUser().name,
                        surname: loggedUser().surname,
                        avatarThumbnailMUrl: loggedUser().avatarThumbnailMUrl,
                        avatarUrl: loggedUser().avatarUrl
                    }">
                </user-avatar>
                <span class="icon icon-arrow-down-s margin-left-8" aria-hidden="true"></span>
            </button>
            <kendo-popover
                #userLoggedOptions
                [width]="'auto'"
                [position]="'bottom'"
                [callout]="false"
                [offset]="10"
                [animation]="{type: 'fade', duration: 150, direction: 'down'}"
                (shown)="onPopoverShown($event, 'logged-user-menu')">
                <ng-template kendoPopoverBodyTemplate>
                    <ul class="dropdown__list" role="menu">
                        <!-- User profile -->
                        <li role="none">
                            <a
                                role="menuitem"
                                class="dropdown__link"
                                [translate]="'global.navbar.myAccount'"
                                [routerLink]="'/profile'"
                                (click)="userLoggedMenu.hide()"></a>
                        </li>
                        <!-- Privacy policy -->
                        <li role="none">
                            <a
                                role="menuitem"
                                class="dropdown__link"
                                [translate]="'global.privacyPolicy'"
                                [routerLink]="privacyPolicyUrlBasedOnLang"
                                rel="noopener noreferrer"
                                target="_blank"
                                (click)="userLoggedMenu.hide()"></a>
                        </li>
                        <!-- Terms and conditions -->
                        <li role="none">
                            <a
                                role="menuitem"
                                class="dropdown__link"
                                [translate]="'global.termsAndConditions'"
                                [routerLink]="termsAndCondsUrlBasedOnLang"
                                rel="noopener noreferrer"
                                target="_blank"
                                (click)="userLoggedMenu.hide()"></a>
                        </li>
                        <!-- Personal data treatment -->
                        <li role="none">
                            <a
                                role="menuitem"
                                class="dropdown__link"
                                [translate]="'global.personalDataTreatment'"
                                [routerLink]="dataTreatmentUrlBasedOnLang"
                                rel="noopener noreferrer"
                                target="_blank"
                                (click)="userLoggedMenu.hide()"></a>
                        </li>
                        <li role="separator" aria-hidden="true">
                            <span class="flex dropdown__separator"></span>
                        </li>
                        <!-- User logout -->
                        <li role="none">
                            <button
                                type="button"
                                role="menuitem"
                                class="dropdown__link logout"
                                [translate]="'global.navbar.logout'"
                                (click)="userLogout()"></button>
                        </li>
                    </ul>
                </ng-template>
            </kendo-popover>
        </article>
    </header>
}
